export const PENJUALAN_CABANG_GET_REQUEST = "PENJUALAN_CABANG_GET_REQUEST";
export const PENJUALAN_CABANG_GET_SUCCESS = "PENJUALAN_CABANG_GET_SUCCESS";
export const PENJUALAN_CABANG_GET_FAIL = "PENJUALAN_CABANG_GET_FAIL";
export const PENJUALAN_CABANG_GET_RESET = "PENJUALAN_CABANG_GET_RESET";
